import { Link } from "react-router-dom";
import Header from "./Header";
import { NoticeRegion } from "../lib/notices";

export default function Footer() {
  return (
    <footer className="border-t brutal-border border-l-0 border-r-0 border-b-0 mt-20 bg-surface" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-display font-black text-xl tracking-tight">DemoCraft</div>
          <p className="text-sm text-ink-muted mt-3 leading-relaxed">
            Turn rough product ideas, screenshots, and voice notes into polished SaaS demo videos.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-ink-muted mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Features</Link></li>
            <li><Link to="/pricing" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Pricing</Link></li>
            <li><Link to="/templates" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Templates</Link></li>
            <li><Link to="/gallery" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Demo Gallery</Link></li>
            <li><Link to="/use-cases" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Use Cases</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-ink-muted mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/faq" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">FAQ</Link></li>
            <li><Link to="/contact" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Contact</Link></li>
            <li><Link to="/security" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Security</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-ink-muted mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-ink-muted hover:text-ink-accent underline-offset-4 hover:underline">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 border-t brutal-border border-l-0 border-r-0 text-xs text-ink-muted flex flex-wrap justify-between gap-4">
        <span>© {new Date().getFullYear()} CloudCraft Labs. All rights reserved.</span>
        <span>Your product assets stay private. You control what gets exported.</span>
      </div>
    </footer>
  );
}

export function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* The skip link lives in Header so authed routes get it too. */}
      <Header />
      <main id="main" tabIndex={-1} className="flex-1">
        {/* Messages sit in the document flow at the top of the content, not
            floating over it — see src/lib/notices.jsx. */}
        <NoticeRegion className="max-w-7xl mx-auto px-6 md:px-10 pt-6" />
        {children}
      </main>
      <Footer />
    </div>
  );
}
